
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Mail } from 'lucide-react';

interface EmailFieldProps {
  form: any;
}

const EmailField: React.FC<EmailFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="email"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Mail className="w-4 h-4" />
            Adresse email *
          </FormLabel>
          <FormControl>
            <Input
              type="email"
              placeholder="votre.email@exemple.com"
              {...field}
              className="h-12"
              readOnly
              style={{ backgroundColor: '#f9fafb' }}
            />
          </FormControl>
          <FormDescription>
            L'email ne peut pas être modifié pour des raisons de sécurité
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default EmailField;
